import React, {useContext} from 'react';
import css from './UserFullNameWithPicture.module.scss';
import FlexContainer from '../../FlexContainer/FlexContainer.jsx';
import PropTypes from 'prop-types';
import {CurrentHotelContext} from '../../../contexts/CurrentHotelContext.jsx';
import Avatar from '../../Avatar/Avatar.jsx';

const UserFullNameWithPicture = ({
  userFullName,
  userProfilePicSrc,
  userId,
}) => {
  const {hotelEmployees} = useContext(CurrentHotelContext)

  const user = userId && hotelEmployees ? hotelEmployees[userId] : null
  let userProfilePicUrl = userId ? null : userProfilePicSrc;
  let username = userId ? '-' : userFullName;
  if (user) {
    userProfilePicUrl = user.pictures?.['30s'];
    username = user.fullName;
  }

  return (
    <FlexContainer className={css.userContainer} alignItems="center" flexWrap="nowrap" gap="5px">
      {userProfilePicUrl ?
        <img
          src={userProfilePicUrl}
          alt={username}
          className={css.profilePicture}
        />
        :
        <div className={css.avatarWrapper}>
          <Avatar name={username}/>
        </div>
      }
      <span className={css.username}>
        {username}
      </span>
    </FlexContainer>
  )
}

UserFullNameWithPicture.propTypes = {
  userId: PropTypes.number,
};

export default UserFullNameWithPicture;
